module.exports = __webpack_public_path__ + "static/media/boat.6781d40a.mov";